import { COLOR } from "@dmm-com/rocket-web-ui-library";
import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import type { LoadingProps } from ".";
import { Z_INDEX } from "~/styles/z-index";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

export const DivContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${Z_INDEX.LOADING_OVERLAY};

  display: flex;
  justify-content: center;
  align-items: center;

  height: 100vh;
  width: 100%;
  height: -webkit-fill-available;
  /* HACK : Chromeでは作動させないようにするHack */
  @supports (-webkit-touch-callout: none) {
    /* The Hack for Safari and mobile viewport bug fix */
    height: -webkit-fill-available;
  }

  background-color: rgba(${COLOR.GRAY50.rgb}, 0.6);
`;

export const DivLoadingWrapper = styled.div<Pick<LoadingProps, "size">>`
  animation: ${spin} 1000ms infinite linear;
  position: absolute;

  ${({ size }) => css`
    top: calc(50% - ${size / 2}px);
    left: calc(50% - ${size / 2}px);

    && svg {
      width: ${size}px;
      height: ${size}px;
    }
  `}
`;
